function RenameFolderViewModel() {
    return {};
}

export default RenameFolderViewModel;
